import React from 'react'
import { Updater, fromJSX, IOWidget } from 'widgets-for-react'
import { AZNavigationLayout, AZNavigationLayoutProps } from './azNavigationLayout'
import { AZNavigationState } from './azNavigationState'

export const azNavigationWidget =
  (props: AZNavigationLayoutProps): IOWidget<AZNavigationState, Updater<AZNavigationState>> =>
  (state) =>
    fromJSX((onDone) => (
      <AZNavigationLayout {...props} onDone={onDone} state={state} secondPagination={props.secondPagination} />
    ))
